<!-- 支付链接 -->
<template>
  <div class="">

    <!-- 图片标题 -->
    <div class="">
      <div class="pannel-pay-title">
        <img src="/imgs/title_wx.jpg" />
      </div>
    </div>

    <!-- 订单号 -->
    <OrderIdComp :order-info="orderInfo" />

    <!--  -->
    <div class="pannel" style="" v-if="orderInfo.orderId">
      <table class="details" style="">
        <tr>
          <td>支付链接</td>
          <td>
            <span v-if="cptyDaifuUrlIf" style="color: green;">已复制</span>
            <button @click="copyDaifuUrl" class="btn copy">复制链接</button>
          </td>
        </tr>
        <tr>
          <td colspan="2" style="text-align:center;">
            <div style="font-size: 0.75em;">
              <p style="color: red;">如果复制不到链接，请手动复制下面框内链接</p>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2" style="text-align:center;">
            <textarea style="border:1;background-color:rgba(241,241,241,.98);width:94%;height:100px;padding:5px;" readonly v-model="orderInfo.payUrl"></textarea>
          </td>
        </tr>
      </table>
    </div>

    <!-- 倒计时 -->
    <TimerComp2 :order-info="orderInfo" :pay-time-info="payTimeInfo" />

    <!--链接-->
    <div class="pannel-btn">
      <div>
        <a href="weixin://" class="btn btn-weix" style="width: 70%;">立即打开微信</a>
      </div>
    </div>

    <!-- time tips -->
    <TimeTipsComp :order-info="orderInfo" />

    <!-- 付款流程 -->
    <div class="pannel">
      <div class="pay-flow">
        <p style="color: #4CAF50;"><b>付款流程：</b></p>
        <p class="no">1、打开微信聊天</p>
        <p class="no">2、随便找个好友（或自己）的聊天界面</p>
        <p class="no">3、发送链接给他，并点击链接进入</p>
      </div>
    </div>

    <!-- 警告事项 -->
    <div class="pannel-simp attention">
      <p class="">
        <span style="color:#4CAF50;"><b>注意</b></span>：<span style="color: red;">超时支付，修改金额，修改支付方式，重复支付，</span>无法追回!!!
      </p>
      <p class="">
        <span style="color:#4CAF50;"><b>注意</b></span>：<span style="color: red;">次日前未查，</span>无法追回!!!
      </p>
      <p class="">
        <span style="color:#4CAF50;"><b>注意</b></span>：支付成功确认时间<span style="color: red;">5-10分钟</span>,付款后<span style="color: red;">超过10分钟</span>还未到账,请联系客服查单补单!
      </p>
    </div>

  </div>
</template>

<script>
import OrderIdComp from "@/views/comp/slot_order_id_comp";
import TimerComp2 from "@/views/comp/slot_timer_comp2";
import TimeTipsComp from "@/views/comp/slot_time_tips_comp";
export default {
  components: {
    OrderIdComp,
    TimerComp2,
    TimeTipsComp,
  },
  props: {
    orderInfo: {
      type: Object,
      default() {
        return {
          payUrl: "",
        };
      },
    },
    payTimeInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      // 复制相关
      cptyDaifuUrlIf: false,
    };
  },
  computed: {},
  created() {},
  methods: {
    // 复制代付链接
    copyDaifuUrl: function () {
      this.$parent.$parent.copySome(
        this.orderInfo.payUrl,
        2,
        () => {
          this.cptyDaifuUrlIf = true;
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
  },
};
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
</style>
